import { PROVINCE_SEPARATOR } from "./constants";

let countries = {
  'USA' : {displayName:'United States', synonyms:['U.S.A.', 'America', 'US', 'U.S.']},
  'UK'  : {displayName:'United Kingdom', synonyms:['U.K.']}
}
let provinces = {
  'D.C.' : {displayName:'Washington, D.C.', synonyms:['DC', 'District of Columbia', 'Washington DC']},
  'New York' : {displayName:'New York', synonyms:['NY']},
  'New Jersey' : {displayName:'New Jersey', synonyms:['NJ']},
  'Massachusetts' : {displayName:'Massachusetts', synonyms:['MA', 'Mass']},
  'Hawaii' : {displayName:'Hawaiʻi', synonyms:['HI']},
}

export function getCountryDetails(countryKey) {

  let country = countries[countryKey];
  if (!country) {
    country = {displayName:countryKey, synonyms:[]};
  }

  return country;

}

export function getProvinceDetails(provinceKey) {

  let province = provinces[provinceKey];
  if (!province) {
    province = {displayName:provinceKey, synonyms:[]};
  }

  return province;

}

export function getCountryId(country) {
  return country.replace(/\s/gi, '_').replace(/-/gi, '_').replace(/\./gi, '').replace(/'/gi, '').replace(/é/gi, 'e').toLowerCase();
}

export function getProvinceId(province) {
  return province.replace(/\s/gi, '_').replace(/-/gi, '_').replace(/\./gi, '').replace(/'/gi, '').replace(/é/gi, 'e').toLowerCase();
}

export function getFullProvinceId(country_province) {

  let tokens = country_province.split(PROVINCE_SEPARATOR);
  let country = tokens[0];
  let province = tokens[1];

  let id = `${ getCountryId(country) }${ PROVINCE_SEPARATOR }${ getProvinceId(province) }`;
  return id;
}
